module.exports = __webpack_public_path__ + "static/media/Petrol.6d814b3b.svg";